import { ConfigFilterItem, ConfigItem } from 'Core/interfaces'

export enum OrderBasicFields {
	id = 'id',
	bol = 'bol',
	item = 'item',
	status = 'status',
	serviceSite = 'serviceSite',
	serviceDate = 'serviceDate',
	orderQuantity = 'orderQuantity',
	purchaseOrder = 'purchaseOrder',
	confirmedQuantity = 'confirmedQuantity',
	disposalFacility = 'disposalFacility'
}

export enum OrderMainSearchFields {
	id = 'searchByOrderId',
	itemName = 'searchByItemName',
	itemId = 'searchByItemId'
}

export enum OrderFilterFields {
	startDate = 'startDate',
	endDate = 'endDate',
	status = 'status',
	serviceSite = 'serviceSite'
}

export declare namespace Order {
	interface Basic {
		[OrderBasicFields.id]: number
		[OrderBasicFields.bol]: BasicString
		[OrderBasicFields.item]: Entity | null
		[OrderBasicFields.status]: Entity | null
		[OrderBasicFields.serviceSite]: Entity | null
		[OrderBasicFields.serviceDate]: BasicString
		[OrderBasicFields.orderQuantity]: number
		[OrderBasicFields.purchaseOrder]: BasicString
		[OrderBasicFields.confirmedQuantity]: number
		[OrderBasicFields.disposalFacility]: BasicString
	}

	namespace Search {
		interface Config {
			[OrderMainSearchFields.id]: ConfigItem<OrderMainSearchFields>
			[OrderMainSearchFields.itemName]: ConfigItem<OrderMainSearchFields>
			[OrderMainSearchFields.itemId]: ConfigItem<OrderMainSearchFields>
		}

		interface Result {
			[OrderMainSearchFields.id]: number[]
			[OrderMainSearchFields.itemName]: string[]
			[OrderMainSearchFields.itemId]: number[]
		}
	}

	namespace Filter {
		interface Config {
			[OrderFilterFields.startDate]: ConfigFilterItem<string, null>
			[OrderFilterFields.endDate]: ConfigFilterItem<string, null>
			[OrderFilterFields.status]: ConfigFilterItem<string, string>
			[OrderFilterFields.serviceSite]: ConfigFilterItem<string, string>
		}
	}
	interface Statistic {
		accepted: number
		waitingForResponse: number
		submitted: number
		declinedBySupplier: number
		rejected: number
		total: number
	}
}
